import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';


// Crea la raíz de la aplicación usando createRoot
const root = ReactDOM.createRoot(document.getElementById('root'));

// Renderiza el componente principal
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

